module.exports = __webpack_public_path__ + "img/caroff_2.41e9959b.png";